export default function() {
  const btns = document.querySelectorAll('.gform_wrapper input[type="submit"], .gform_wrapper input[type="button"]');

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if(document.querySelectorAll('#gf_form_focus').length) {
        document.querySelectorAll('#gf_form_focus').forEach((el) => {
          el.parentNode.removeChild(el);
        });
      }
    })
  })
}
